// react-datepicker format tokens keyed off the account country (epic Open
// Technical Constraints, T5). The US writes the month first (mm/dd/yyyy); every
// other market writes the day first (dd/mm/yyyy). Country code matches the
// existing `country.code === "US"` convention used across the builder.
export const getDatePickerDateFormat = (countryCode?: string | null): string =>
  countryCode === "US" ? "MM/dd/yyyy" : "dd/MM/yyyy";
